// @flow
import styled, { css } from 'styled-components';
import { space } from 'styled-system';
import { breakpoints, colors, textStyles } from '../theme';

const getStyle = (style: 'default' | 'modal' | 'form') => {
  if (style === 'modal') {
    return css`
      padding: 16px 16px;
      @media (min-width: ${breakpoints[2]}) {
        padding: 25px 25px;
      }
    `;
  }
  if (style === 'form') {
    return css`
      padding: 12px;
      color: ${colors.steelGrey};
      @media (min-width: ${breakpoints[2]}) {
        padding: 20px;
      }
      ${textStyles.bodySmall}
      line-height: 1.375;
    `;
  }
  return css`
    padding: 16px 24px;
    @media (min-width: ${breakpoints[2]}) {
      padding: 24px 32px;
    }
  `;
};

const getBorder = (type: ?('info' | 'warning' | 'danger')) => {
  if (!type) {
    return null;
  }
  let color = colors.waterBlue;

  if (type === 'warning') {
    color = colors.dandelion;
  } else if (type === 'danger') {
    color = colors.scarlet;
  }
  return css`
    border-left: solid 4px ${color};
  `;
};

const InfoBox = styled.div`
  border-radius: 4px;
  background-color: ${props =>
    props.small ? colors.platinum : colors.offWhite};
  ${props =>
    props.small
      ? `
    padding: 4px 12px;
  `
      : getStyle(props.boxStyle)};
  ${props => props.type && getBorder(props.type)};
  ${space};
  a {
    display: inline;
    color: ${colors.oceanBlue};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export default InfoBox;
